import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle = ({ className = '' }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      className={`group relative inline-flex items-center justify-center w-9 h-9 rounded-full border border-[#E5DCC8] dark:border-[#1A2952] bg-white dark:bg-[#0F1B3D] hover:bg-[#FAF6EE] dark:hover:bg-[#1A2952] transition-all ${className}`}
      data-testid="theme-toggle-btn"
    >
      {isDark ? (
        <Sun className="h-4 w-4 text-[#FAF6EE]" />
      ) : (
        <Moon className="h-4 w-4 text-[#0F1B3D]" />
      )}
    </button>
  );
};
